import type { JSX } from 'react'

export const TableIcon = (): JSX.Element => (
  <use href='#tableIcon' height='100%' width='100%' />
)
